export default [
  {
    path: "/monthly-parking-permit",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: ":id",
        name: "Monthly Parking Permit",
        component: () => import("@/views/MonthlyParkingPermit/MonthlyParkingPermit.vue")
      },
      {
        path: "confirmation/:orderId",
        name: "Monthly Parking Permit Confirmation",
        props: true,
        component: () => import("@/views/MonthlyParkingPermit/MonthlyParkingPermit.vue"),
        meta: { confirmation: true, failure: false }
      },
      {
        path: "failure/:orderId",
        name: "Monthly Parking Permit Failure",
        component: () => import("@/views/MonthlyParkingPermit/MonthlyParkingPermit.vue"),
        props: true,
        meta: { confirmation: false, failure: true }
      }
    ]
  }
];
